import React from 'react'
import PropTypes from 'prop-types'

import { MessageErrorInput } from 'Components/Message/Error/input'
import { useFormChildLogic } from '../index'

const TextareaUnstyled = props => {
  const {
    validator,
    name,
    initValue,
    onChange: onChangeProp,
    input = {},
  } = props

  const { updateForm, value: formValue, error } = useFormChildLogic({
    name,
    validator,
    initValue,
  })

  const value = formValue || input.value
  const onChange = onChangeProp || input.onChange

  const handleChange = e => {
    onChange && onChange(e)
    updateForm(e.target.value)
  }

  return (
    <div className={props.className}>
      {props.label && (
        <label htmlFor={`textarea-${props.id}`}>{props.label}</label>
      )}
      <textarea
        id={`textarea-${props.id}`}
        placeholder={props.placeholder}
        onChange={handleChange}
        onBlur={props.input.onBlur}
        value={value}
        data-gramm_editor={props.disableGrammarly}
      />
      {renderError(error)}
    </div>
  )

  /**
   * Select input has error
   * @returns boolean
   */
  function hasError(error) {
    return (props.meta && props.meta.touched && props.meta.error) || error
  }

  /**
   * Render field error
   * @returns JSX.Element | null
   */
  function renderError(error) {
    const inputError = (props.meta && props.meta.error) || error

    return hasError(error) ? (
      <MessageErrorInput key="errorMessage" message={inputError} />
    ) : null
  }
}

TextareaUnstyled.defaultProps = {
  id: 'not-unique',
  disableGrammarly: false,
  className: 'default-textarea',
  label: null,
  placeholder: '',
  input: {
    value: '',
  },
}

TextareaUnstyled.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
  }),
  disableGrammarly: PropTypes.bool,
}

export { TextareaUnstyled }



// WEBPACK FOOTER //
// ./src/Components/Form/Textarea/unstyled.js